// extracted by mini-css-extract-plugin
export default {"buttonBase":"button_buttonBase__pfm2u","hoverFill":"button_hoverFill__NUWFF","innerText":"button_innerText__-eoSH","arrowInnerText":"button_arrowInnerText__qaTM0"};